import { getOrCreateUserId } from '@/utils/auth'
import { commonApi } from '@/api'

export default {
  methods: {
    isMobileDevice () {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    },
    checkAndRedirect () {
      const isMobile = this.isMobileDevice()
      const currentPath = this.$route.path
      const query = this.$route.query
      console.log('check', 'jump', query, currentPath)

      if (isMobile) { // 移动设备
        if (currentPath === '/webChat' || currentPath === '/') { // web客户端页面
          this.$router.replace({ path: '/chat', query: query })
          return true
        }
      } else {
        if (currentPath === '/chat' || currentPath === '/') {
          this.$router.replace({ path: '/webChat', query: query })
          return true
        }
      }
      return false
    }
  },
  created () {
    const userId = getOrCreateUserId()
    commonApi.recordPvUv({ userId: userId, channel: this.$route.query.channel }).then(res => {
      console.log('记录：', res)
    })
    this.checkAndRedirect()
  }
}
